import * as React from "react";
const SvgCleanSoap = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.498 2.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm-2 6.781a2.75 2.75 0 0 1 2.75-2.75h3.279a3.75 3.75 0 0 1 7.442 0h7.283a2.75 2.75 0 0 1 2.75 2.75v8a2.75 2.75 0 0 1-2.599 2.746 3.747 3.747 0 0 1-5.754.677 2.25 2.25 0 0 1-4.088-.672H2.998a2.75 2.75 0 0 1-2.75-2.75v-8Zm1.5 6.45v1.55c0 .69.56 1.25 1.25 1.25h8.468a2.25 2.25 0 0 1 2.83-1.135c.08-.494.257-.956.51-1.365H2.998c-.45 0-.875-.108-1.25-.3Zm19.988 2.562c.313-.227.516-.596.516-1.012v-1.55a2.734 2.734 0 0 1-1.066.294 3.732 3.732 0 0 1 .55 2.268Zm.516-5.012v-4c0-.69-.56-1.25-1.25-1.25H2.998c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h13.5l.066.003a3.738 3.738 0 0 1 1.434-.284c.505 0 .987.1 1.427.281h1.577c.69 0 1.25-.56 1.25-1.25ZM12.2 7.531a2.25 2.25 0 0 0-4.402 0h4.402ZM15.748 19a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm-3 1.5a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCleanSoap;
